import ICTconsultancyOffers from "./ICTconsultancyOffers";

const ICTconsultancy = () => {
  return (
    <section className="solution-item-page">
      <ICTconsultancyOffers />
    </section>
  ); 
};

export default ICTconsultancy;
